<template>
	<div :class="[$style.wrapper, wide && $style.wide]" >
		<div class="d-flex justify-space-between" :class="disabled ? $style.disabled : ''">
			<div class="ao-c2 ao-text-secondary-color-700 align-self-center">{{ title }}</div>
			<v-spacer/>
				<div v-if="paramsButtonsItems">
					<ao-button-toggle
						:modelValue="modelValue"
						:items="paramsButtonsItems"
						class="mr-2"
						@update:modelValue="$emit('update:modelValue', $event)"
					/>
				</div>
				<v-spacer/>
			<div :class="$style.actions">
				<slot name='action'/>
				<div :class="$style.dp">
					<!-- TODO: вынесете дейт пикер в слот -->
					<!-- <ao-date-range-picker
						:model-value="date"
						v-if="showDatePicker"
						@update:modelValue="
							(payload) => {
								date = payload.range
							}
						"
					>
						<v-text-field
							v-model="getFormattedDate"
							:class="$style.input"
							color="secondary"
							density="compact"
							variant="text"
							hide-details
						>
							<template v-slot:prepend-inner>
								<ao-icon
									class="ao-p2-medium"
									iconName="calendarView"
								/>
							</template>
						</v-text-field>
					</ao-date-range-picker> -->
				</div>
				<ao-icon-btn
					:class="$style.wide_icon"
					iconName="sizeMx"
					size="24"
					variant="text"
					@click="handleToggleWide"
				/>
			</div>
		</div>
		<div v-if="showSlot">
		<slot />
		</div>
	</div>
</template>

<script>
const padTo2Digits = (num) => num.toString().padStart(2, '0')

const formatDate = (d) => {
	const date = new Date(d)

	return [
		padTo2Digits(date.getDate()),
		padTo2Digits(date.getMonth() + 1),
		(date.getFullYear() + '').slice(2, 4),
	].join('.')
}

export default {
	name: 'PassportInfoBlock',
	props: {
		modelValue: {
			type: String,
		},
		title: {
			type: String,
			default: 'Расход топлива',
		},
		showDatePicker:{
			type: Boolean,
			default: true,
		},
		disabled:{
			type: Boolean,
			default: false,
		},
		paramsButtonsItems:{
			type: Array,
			default: null,
		},
		needUpdate:{
			type: Boolean,
			default: false,
		},
		date: String,
	},
	emits: {
		openedFullScreen: null,
	},
	data() {
		return {
			wide: false,
			showSlot:true
		}
	},
	computed: {
		getFormattedDate: {
			get() {
				if (this.date) {
					const formattedDates = [formatDate(this.date[0]), formatDate(this.date[1])]

					return formattedDates.join(' - ')
				}
			},
		},
	},
	methods: {
		handleToggleWide() {
			this.wide = !this.wide
			this.$emit('openedFullScreen', this.wide)
		},
	},
	watch: {
		wide(val) {
			if(this.needUpdate){
				this.showSlot=false;
				this.$nextTick(() => {
				this.showSlot=true;
				})
			}
		},
	},
}
</script>

<style module lang="scss">
.wrapper {
	background: white;
	padding: 8px 16px;
}

.wrapper.wide {
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 10000;
}

.actions {
	display: flex;
	align-items: center;
	gap: 4px;

	.dp {
		width: 127px;
	}
}

.input {
	&:global(.v-text-field) {
		padding-top: 0;
		margin-top: -1px;
	}
	:global(.v-field__input) {
		font-size: 10px !important;
		padding: 0;
		align-self: center;
		height: 14px;
		letter-spacing: 0;
	}

	:global(.v-field__prepend-inner) {
		align-self: center;
		width: 12px;
		height: 12px;
		align-items: center;
		display: flex;
		margin-right: 4px;
		padding-top: 0;
	}

	:global(.v-field) {
		height: 24px;
		border: 1px solid #d9e3ee;
		font-size: 12px;
		border-radius: 4px;
		box-sizing: border-box;
		padding: 4px 0 4px 8px;
	}
}

.wide_icon {
	border: 1px solid #d9e3ee;
	font-size: 12px;
	border-radius: 4px;
}
.disabled{
	opacity:0.5;
}
</style>
